module.exports = __webpack_public_path__ + "img/reddit.d52c90bf.svg";